import {useIntl} from 'react-intl';
import ClientsUI from './ClientsUI';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {useState} from 'react';
import {useEffect} from 'react';
import jwtAxios from '@crema/services/auth/jwt-auth';
import {fetchError, showMessage} from 'redux/actions';

const ClientsLG = () => {
  const {messages} = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [customers, setCustomers] = useState([]);
  const [customersCount, setCustomersCount] = useState(0);
  const [page, setPage] = useState(0);
  const [search, setSearchQuery] = useState('');
  const [domainMapping, setDomainMapping] = useState({});

  const onPageChange = (event, value) => {
    setPage(value);
  };

  const onSearchCustomer = (e) => {
    setSearchQuery(e);
    setPage(0);
  };

  const OpenAddCustomer = () => {
    navigate('/clients/add-client');
  };

  const getDomains = () => {
    jwtAxios
      .get('domain/search?pageSize=100&pageNumber=0&term=')
      .then((response) => {
        const mapping = {};
        response.data.data.forEach((domain) => {
          mapping[domain.id] = domain.domain_name;
        });
        setDomainMapping(mapping);
      })
      .catch((e) => {
        dispatch(fetchError(e.message));
      });
  };

  const getCustomers = (pageSize, pageNumber, search) => {
    const url = search
      ? `customer/search?pageSize=${pageSize}&pageNumber=${pageNumber}&term=${search}`
      : `customer?pageSize=${pageSize}&pageNumber=${pageNumber}`;
    jwtAxios
      .get(url)
      .then((e) => {
        setCustomers(e.data.data.data);
        setCustomersCount(e.data.data.dataCount);
      })
      .catch((e) => {
        dispatch(fetchError(e.message));
      });
  };
  const deleteCustomer = (id) => {
    jwtAxios
      .delete(`customer/${id}`)
      .then(() => {
        dispatch(showMessage('sccusfully data deleted id= ' + id));
        getCustomers(1000, page, search);
      })
      .catch((e) => {
        dispatch(fetchError(e.message));
      });
  };

  useEffect(() => {
    getDomains();
  }, []);

  useEffect(() => {
    if (search) {
      const getData = setTimeout(() => {
        getCustomers(1000, page, search);
      }, 2000);
      return () => clearTimeout(getData);
    }
    getCustomers(1000, page, search);
  }, [page, search]);

  return (
    <ClientsUI
      page={page}
      onPageChange={onPageChange}
      customers={customers}
      customerCount={customersCount}
      messages={messages}
      onSearchCustomer={onSearchCustomer}
      OpenAddCustomer={OpenAddCustomer}
      deleteCustomer={deleteCustomer}
      domainMapping={domainMapping}
    />
  );
};

export default ClientsLG;
